import { Configuration } from "./Configuration";
import { Product } from "./Product";

export const STATE_TRANSLATOR = {
  draft: "Borrador",
  signed: "Emitida",
  sent: "Enviada",
  sent_via_mail: "Enviada por mail",
  paid: "Pagado",
  lost_connection: "Conexión perdida",
  rejected: "Rechazada",
  b_rejected: "Rechazado",
  error: "Error",
  issued: "Emitido",
  accepted: "Aceptado",
  invoiced: "Facturado",
  b_sent: "Enviado"
};

export const PAYMENT_STATE_TRANSLATOR = {
  unpaid: "No pagada",
  paid: "Pagada",
  partially_paid: "Parcialmente pagada",
  overpaid: "Sobrepagada",
  overdue: "Vencida",
  pending: "Pendiente",
  rectified: "Rectificada",
  remitted: "Remesada",
};

export const recargo_rates = {0.052:0.21, 0.014:0.1, 0.005:0.04}
export class Tax {
    rate: number;
    base: number;
    amount: number;
    recargo_rate?: number;
    recargo_amount?: number;

    constructor(rate: number, base: number, amount: number, recargo_rate?: number, recargo_amount?: number) {
        this.rate = rate;
        this.base = base;
        this.amount = amount;
        this.recargo_rate = recargo_rate;
        this.recargo_amount = recargo_amount;
    }
}

export class ExtraAmount {
  reason: string;
  amount?: number;
  rate?: number;

  constructor(reason: string, amount?: number, rate?: number) {
      this.reason = reason;
      this.amount = amount;
      this.rate = rate;
  }
}

export class ReceiverInfo {
  budget_number: string = '';
  budget_date: string  = '';

  constructor(budget_number: string='', budget_date: string='') {
    this.budget_number = budget_number;
    this.budget_date = budget_date;
  }
}

export class SenderInfo {
  budget_number: string = '';
  budget_date: string = '';

  constructor(budget_number: string='', budget_date: string='') {
    this.budget_number = budget_number;
    this.budget_date = budget_date;
  }
}


export class AdditionalInformation {
  sender_info : SenderInfo = new SenderInfo();
  receiver_info: ReceiverInfo = new ReceiverInfo();
  delivery_note_number: string = '';
  delivery_note_date: string = '';
  additional_line_information: string = '';

  constructor(sender_info: SenderInfo, receiver_info: ReceiverInfo, delivery_note_number: string, delivery_note_date: string, additional_line_information: string = '') {
    this.sender_info = sender_info;
    this.receiver_info = receiver_info;
    this.delivery_note_number = delivery_note_number
    this.delivery_note_date = delivery_note_date;
    this.additional_line_information = additional_line_information;
  }
}

export class InvoiceLine {
    description: string;
    quantity: number;
    unit_price_without_tax: number;
    total_cost: number;
    gross_amount: number;
    taxes: Tax[];
    taxes_withheld : Tax[];
    selected_retention?:any;
    selected_tax?:any;
    id?: number;
    selected_product?: Product;
    product_code?:string;
    selected_tax_event?: string
    special_taxable_event?: Object;
    additional_information?: AdditionalInformation;
    discounts: ExtraAmount[];

    constructor(
      description: string,
      quantity: number,
      unit_price_without_tax: number,
      total_cost: number,
      gross_amount: number,
      taxes: Tax[],
      taxes_withheld?: Tax[],
      id?: number,
      selected_retention?: any,
      selected_tax?: any,
      selected_product?: Product,
      product_code?: string,
      selected_tax_event?: string,
      special_taxable_event?: Object,
      additional_information?: AdditionalInformation,
      discounts?: ExtraAmount[]
    ) {
        this.description = description;
        this.quantity = quantity;
        this.unit_price_without_tax = unit_price_without_tax;
        this.total_cost = total_cost;
        this.gross_amount = gross_amount;
        this.taxes = taxes;
        if(selected_retention){
          this.selected_retention = selected_retention;
        }
        else{
          this.selected_retention = 'na';
        }
        if(selected_tax || selected_tax===0){
          this.selected_tax = selected_tax;
        }
        else {
          this.selected_tax = 0.21;
        }
        if (taxes_withheld){
          this.taxes_withheld = taxes_withheld;
        }
        else{
          this.taxes_withheld = [];
        }
        this.id = id;
        if (selected_product) {
          this.selected_product = selected_product;
        }
        this.product_code = product_code;
        if(selected_tax_event){
          this.selected_tax_event = selected_tax_event;
        }
        else{
          this.selected_tax_event = 'N/A';
        }
        this.special_taxable_event = special_taxable_event;
        this.additional_information = additional_information;
        this.discounts = discounts ? discounts : [];
    }

    toString(): string {
        return `${this.id} - ${this.description} - ${this.quantity} - ${this.unit_price_without_tax} - ${this.total_cost} - ${this.gross_amount} - ${this.taxes}`;
    }

    clone(): InvoiceLine {
        return new InvoiceLine(
          this.description,
          this.quantity,
          this.unit_price_without_tax,
          this.total_cost,
          this.gross_amount,
          this.taxes.map(tax => tax),
          this.taxes_withheld.map(tax => tax),
          this.id,
          this.selected_retention,
          this.selected_tax,
          this.selected_product ? this.selected_product.clone() : null,
          this.product_code,
          this.selected_tax_event,
          this.special_taxable_event,
          this.additional_information,
          this.discounts.map(d => d)
        );
    }

    iamvalid(): boolean{
      if (['', null, undefined].includes(this.description)){ //acceptem tmeporalment linies a zero.
      // if (['', null, undefined].includes(this.description) || this.quantity==0 || this.unit_price_without_tax ==0){
        return false;
      }
      return true;
    }

    updateLine(): InvoiceLine {
      const actual_round = (value: number) => Math.round(value * 100) / 100;
      let line = this.clone();

      if (line.selected_product) {
          line.product_code = line.selected_product.code
          line.description = line.selected_product.description
          line.unit_price_without_tax = line.selected_product.price
          line.selected_tax = line.selected_product.selected_tax
          line.selected_retention = line.selected_product.selected_retention
          if (line.selected_product.selected_tax == 0.0 && line.selected_product.selected_tax_event) {
              line.selected_tax_event = line.selected_product.selected_tax_event
          }
          if (line.quantity == 0){
              line.quantity = 1
          }
          line.selected_product = null
      }

      let reason = ''
      if (line.selected_tax_event){
          if (line.selected_tax_event == 'ISP'){
              reason = 'Inversión del sujeto pasivo en virtud del art 84.Uno de la Ley 37/1992, del IVA.'
              line.special_taxable_event = {code:'01', reason:reason}
          }
          else if (line.selected_tax_event == 'NS'){
              reason  = 'Operación no sujeta a IVA en virtud del art. 7 de la Ley 37/1992, del IVA.'
              line.special_taxable_event = {code:'02', reason:reason}
          }
          else if (line.selected_tax_event == 'EX'){
              reason = 'Operación exenta en virtud del art. 20 de la Ley 37/1992, del IVA.'
              line.special_taxable_event = {code:'01', reason:reason}
          }
          else if(line.selected_tax_event == 'INTRA.'){
              reason = 'Entrega intracomunitaria exenta en virtud del art. 25 de la Ley 37/1992, del IVA.'
              line.special_taxable_event = {code:'01', reason:reason}
          }
          else if(line.selected_tax_event == 'EXPORT.'){
              reason = 'Operación exenta por exportación en virtud del art. 21 de la Ley 37/1992, del IVA.'
              line.special_taxable_event = {code:'01', reason:reason}
          }
          else{
              line.special_taxable_event = null
          }
      }
      if (line.selected_tax != 0.0){
          line.selected_tax_event = 'N/A'
          line.special_taxable_event = null
      }
      
      line.total_cost = actual_round(line.quantity * line.unit_price_without_tax)
      line.gross_amount = line.total_cost

      let discount = 0

      if (line.discounts.length > 0 && line.discounts[0].rate>0)
          discount = line.total_cost * line.discounts[0].rate / 100

      line.taxes[0].base = line.total_cost - discount

      if (Object.keys(recargo_rates).includes(line.selected_tax.toString())){
          line.taxes[0].rate = recargo_rates[line.selected_tax]
          line.taxes[0].recargo_rate = line.selected_tax
          line.taxes[0].amount = actual_round(line.taxes[0].base * line.taxes[0].rate)
          line.taxes[0].recargo_amount = actual_round(line.taxes[0].base * line.taxes[0].recargo_rate)
    }
      else{
          line.taxes[0].rate = line.selected_tax
          line.taxes[0].amount = actual_round(line.taxes[0].base * line.taxes[0].rate)
          line.taxes[0].recargo_amount = 0
          line.taxes[0].recargo_rate = null
      }
      line.taxes[0].base = line.total_cost

      if (line.selected_retention == 'na'){
          line.taxes_withheld = []
      }
      else{
          let rate = parseFloat(line.selected_retention)
          line.taxes_withheld = [new Tax(rate, line.taxes[0].base, actual_round(line.taxes[0].base*rate))]
        }
      return line
    }
}

export class Party {
  id: number;
  company_id: string|number;
  cif: string;
  post_code: string;
  type?: string;
  
  name?: string;
  first_surname?: string;
  second_surname?: string;

  business_name?: string;
  trade_name?: string;
  
  address?: string;
  city?: string;
  province?: string;
  email?: string;
  phone?: string;
  website?: string;
  DIRe?: string;
  accounting_office?: string;
  management_body?: string;
  processing_unit?: string;
  proposing_body?: string;
  bank_account_number?: string;
  bic?: string;
  mandate_id?: string;
  mandate_signature_date?: string;
  debit_account?: string;

  constructor(
    id: number,
    company_id: string|number,
    cif: string,
    post_code: string,
    type: string = 'juridica',
    name?: string,
    first_surname?: string,
    second_surname?: string,
    business_name?: string,
    trade_name?: string,
    address?: string,
    city?: string,
    province?: string,
    email?: string,
    phone?: string,
    website?: string,
    DIRe?: string,
    accounting_office?: string,
    management_body?: string,
    processing_unit?: string,
    proposing_body?: string,
    bank_account_number?: string,
    bic?: string,
    mandate_id?: string,
    mandate_signature_date?: string,
    debit_account?: string
  ) {
    this.id = id;
    this.company_id = company_id;
    this.cif = cif;
    this.post_code = post_code;
    this.type = type;
    this.name = name;
    this.first_surname = first_surname;
    this.second_surname = second_surname;
    this.business_name = business_name;
    this.trade_name = trade_name;
    this.address = address;
    this.city = city;
    this.province = province;
    this.email = email;
    this.phone = phone;
    this.website = website;
    this.DIRe = DIRe;
    this.accounting_office = accounting_office;
    this.management_body = management_body;
    this.processing_unit = processing_unit;
    this.proposing_body = proposing_body;
    this.bank_account_number = bank_account_number;
    this.bic = bic;
    this.mandate_id = mandate_id;
    this.mandate_signature_date = mandate_signature_date;
    this.debit_account = debit_account;
  }
  clone(): Party {
    return new Party(
      this.id,
      this.company_id,
      this.cif,
      this.post_code,
      this.type,
      this.name,
      this.first_surname,
      this.second_surname,
      this.business_name,
      this.trade_name,
      this.address,
      this.city,
      this.province,
      this.email,
      this.phone,
      this.website,
      this.DIRe,
      this.accounting_office,
      this.management_body,
      this.processing_unit,
      this.proposing_body,
      this.bank_account_number,
      this.bic,
      this.mandate_id,
      this.mandate_signature_date,
      this.debit_account      
    );
  }

  fromPrimitive(dict: any): Party {
    return new Party(
      dict.id ?? 0,
      dict.company_id ?? '',
      dict.cif ?? '',
      dict.post_code ?? '',
      dict.type ?? 'juridica',
      dict.name ?? '',
      dict.first_surname ?? '',
      dict.second_surname ?? '',
      dict.business_name ?? '',
      dict.trade_name ?? '',
      dict.address ?? '',
      dict.city ?? '',
      dict.province ?? '',
      dict.email ?? '',
      dict.phone ?? '',
      dict.website ?? '',
      dict.DIRe ?? '',
      dict.accounting_office ?? '',
      dict.management_body ?? '',
      dict.processing_unit ?? '',
      dict.proposing_body ?? '',
      dict.bank_account_number ?? '',
      dict.bic ?? '',
      dict.mandate_id ?? '',
      dict.mandate_signature_date ?? '',
      dict.debit_account ?? ''
    );
  }

  toPrimitive(party:Party): any {
    return {
      id: party.id ?? 0,
      company_id: party.company_id ?? '',
      cif: party.cif ?? '',
      post_code: party.post_code ?? '',
      type: party.type ?? '',
      name: party.name ?? '',
      first_surname: party.first_surname ?? '',
      second_surname: party.second_surname ?? '',
      business_name: party.business_name ?? '',
      trade_name: party.trade_name ?? '',
      address: party.address ?? '',
      city: party.city ?? '',
      province: party.province ?? '',
      email: party.email ?? '',
      phone: party.phone ?? '',
      website: party.website ?? '',
      DIRe: party.DIRe ?? '',
      accounting_office: party.accounting_office ?? '',
      management_body: party.management_body ?? '',
      processing_unit: party.processing_unit ?? '',
      proposing_body: party.proposing_body ?? '',
      bank_account_number: party.bank_account_number ?? '',
      bic: party.bic ?? '',
      mandate_id: party.mandate_id ?? '',
      mandate_signature_date: party.mandate_signature_date ?? '',
      debit_account: party.debit_account ?? '',
    };
  }
}

export class RectificativeInfo {
  reason?: string;
  invoice_id?: number;
  invoice_number?: string;
  invoice_date?: string;

  constructor(reason?: string, invoice_id?: number, invoice_number?: string, invoice_date?: string) {
    this.reason = reason? reason : "Motivo: Factura rectificativa por diferencias.";
    this.invoice_id = invoice_id;
    this.invoice_number = invoice_number;
    this.invoice_date = invoice_date;
  }

  clone(): RectificativeInfo {
    return new RectificativeInfo(
      this.reason,
      this.invoice_id,
      this.invoice_number,
      this.invoice_date
    );
  }
}
export class Invoiceable {
    id: number;
    company_id: number;
    total_amount: number;
    total_to_pay: number;
    total_gross_amount: number = 0;
    total_lines_discounts: number = 0;
    total_gross_amount_before_tax: number = 0;
    total_tax_amount: number = 0;
    total_withheld_amount: number = 0;
    invoice_number: string;
    invoice_date: string;
    lines: InvoiceLine[];
    other_amounts?: number;
    total_taxes?: Tax[];
    total_taxes_withheld?: Tax[];
    general_discounts?: ExtraAmount[];
    general_surcharges?: ExtraAmount[];
    reimbursable_amounts?: number[];
    supplier: Party;
    customer: Party;
    state: string;
    invoice_due_date?: string;
    external_invoice_number?:string;
    start_date?: string;
    end_date?: string;
    retention_concept?: string;
    retention_amount?: number;
    kind?: string;
    signing_time?: string;
    sequence_id?: number;
    predicted_invoice_number?: string;
    payment_state?: string;
    accounting_document_id?: number;
    rectificative?: boolean;
    rectificative_info?: RectificativeInfo;
    predicted_rectificative_invoice_number?: string;
    tax_type?: string;
    additional_info?: string;
    free_notes?: string;
    payment_means: string = '00';
    recurring_invoice_contract_id?: number;
    is_from_recurring_contract?: boolean;
    related_invoiceable_ids?: number[];

    constructor(
      id: number,
      company_id: number,
      total_amount: number,
      total_to_pay: number,
      invoice_number: string,
      invoice_date: string,
      invoice_lines: InvoiceLine[],
      other_amounts?: number,
      supplier?: Party,
      customer?: Party,
      state: string = 'draft',
      invoice_due_date?: string,
      external_invoice_number?: string,
      start_date?: string,
      end_date?: string,
      retention_concept?: string,
      retention_amount?: number,
      kind: string = 'out_invoice',
      total_gross_amount: number = 0,
      total_lines_discounts: number = 0,
      total_gross_amount_before_tax: number = 0,
      total_tax_amount: number = 0,
      total_withheld_amount: number = 0,
      total_taxes?: Tax[],
      total_taxes_withheld?: Tax[],
      general_discounts?: ExtraAmount[],
      general_surcharges?: ExtraAmount[],
      reimbursable_amounts?: number[],
      signing_time?: string,
      sequence_id?: number,
      predicted_invoice_number?: string,
      payment_state?: string,
      accounting_document_id?: number,
      rectificative?: boolean,
      rectificative_info?: RectificativeInfo,
      predicted_rectificative_invoice_number?: string,
      tax_type?: string,
      additional_info?: string,
      free_notes?: string,
      payment_means: string = '00',
      recurring_invoice_contract_id?: number,
      is_from_recurring_contract?: boolean,
      related_invoiceable_ids?: number[]
      ) {
        this.id = id;
        this.company_id = company_id;
        this.total_amount = total_amount;
        this.total_to_pay = total_to_pay;
        this.total_gross_amount = total_gross_amount;
        this.total_lines_discounts = total_lines_discounts;
        this.total_gross_amount_before_tax = total_gross_amount_before_tax;
        this.total_tax_amount = total_tax_amount;
        this.total_withheld_amount = total_withheld_amount;
        this.invoice_number = invoice_number;
        this.invoice_date = invoice_date;
        this.lines = invoice_lines;
        this.other_amounts = other_amounts;
        this.supplier = supplier;
        this.customer = customer;
        this.state = state;
        this.invoice_due_date = invoice_due_date;
        this.external_invoice_number = external_invoice_number;
        this.start_date = start_date;
        this.end_date = end_date;
        this.retention_concept = retention_concept;
        this.retention_amount = retention_amount;
        this.kind = kind;
        this.total_taxes = total_taxes;
        this.total_taxes_withheld = total_taxes_withheld;
        this.general_discounts = general_discounts;
        this.general_surcharges = general_surcharges;
        this.reimbursable_amounts = reimbursable_amounts;
        this.signing_time = signing_time;
        this.sequence_id = sequence_id;
        this.predicted_invoice_number = predicted_invoice_number;
        this.payment_state = payment_state;
        this.accounting_document_id = accounting_document_id;
        this.rectificative = rectificative;
        this.rectificative_info = rectificative_info;
        this.predicted_rectificative_invoice_number = predicted_rectificative_invoice_number;
        this.tax_type = tax_type;
        this.additional_info = additional_info;
        this.free_notes = free_notes;
        this.recurring_invoice_contract_id = recurring_invoice_contract_id;
        this.is_from_recurring_contract = is_from_recurring_contract;
        this.related_invoiceable_ids = related_invoiceable_ids;
        this.payment_means = payment_means;
    }

    clone(): Invoiceable {
        let supplier = this.supplier ? this.supplier.clone() : null;
        let customer = this.customer ? this.customer.clone() : null;
        return new Invoiceable(
            this.id,
            this.company_id,
            this.total_amount,
            this.total_to_pay,
            this.invoice_number,
            this.invoice_date,
            this.lines.map(line => line.clone()),
            this.other_amounts,
            supplier,
            customer
            
        );
    }
    get_lines_with_additional_descriptions(){
      // les línies amb "is_..." s'escriuran en el pdf ocupant tota l'amplada. 
      let res = []
      for (let line of this.lines){
          //CAPÇALERA ALBARAN
          if(line.additional_information && (line.additional_information.delivery_note_date||line.additional_information.delivery_note_number)){
            let line0 = {...line}
            line0['is_delivery_note_header'] = true
            const headerExists = res.some(item => 
              item.is_delivery_note_header && 
              item.additional_information &&
              item.additional_information.delivery_note_number === line.additional_information.delivery_note_number &&
              item.additional_information.delivery_note_date === line.additional_information.delivery_note_date
            );
            if (!headerExists) {
              res.push(line0); //afegim el header si no estava ja afegit
            }
          }
          res.push(line)
          //INFORMACIÓ ADICIONAL
          if(line.additional_information && line.additional_information.additional_line_information){
              let line2 = {...line}
              line2['is_additional_info'] = true
              res.push(line2)
          }
      }
      return res
    }
    compute() {
      const actual_round = (value: number) => Math.round(value * 100) / 100;

      const total_taxes: Tax[] = [];
      let total_lines_discounts = 0;
      // Compute total taxes and discounts
      for (const line of this.lines) {
          const quantity = Number(line.quantity);
          if (!isNaN(quantity) && quantity !== 0) {
            let total_tax: Tax | undefined = undefined;
            const line_tax = line.taxes[0];
            for (const t of total_taxes) {
                if (t.rate === line_tax.rate && (t.recargo_rate === line_tax.recargo_rate || (!t.recargo_rate && !line_tax.recargo_rate))) {
                    total_tax = t;
                    break;
                }
            }
            if (!total_tax) {
                total_tax = new Tax(line_tax.rate, 0, 0, line_tax.recargo_rate, 0);
                total_taxes.push(total_tax);
            }
            
            total_tax.base += line_tax.base ?? 0;
            total_tax.amount += line_tax.amount ?? 0 ;
            total_tax.recargo_amount = (total_tax.recargo_amount ?? 0) + (line_tax.recargo_amount ?? 0);

            if (line.discounts.length > 0 && line.discounts[0].rate > 0)
              total_lines_discounts += line.gross_amount * line.discounts[0].rate / 100;
          }
      }
      this.total_taxes = total_taxes;
      this.total_lines_discounts = total_lines_discounts;

      // Compute total withheld taxes
      const total_taxes_withheld: Tax[] = [];
      for (const line of this.lines) {
          const quantity = Number(line.quantity);
          if (line.taxes_withheld && line.taxes_withheld.length > 0 && (!isNaN(quantity) && quantity !== 0)) {
              let total_tax: Tax | undefined = undefined;
              const line_tax = line.taxes_withheld[0];
              for (const t of total_taxes_withheld) {
                  if (t.rate === line_tax.rate) {
                      total_tax = t;
                      break;
                  }
              }
              if (!total_tax) {
                  total_tax = new Tax(line_tax.rate, 0, 0);
                  total_taxes_withheld.push(total_tax);
              }

              total_tax.base += line_tax.base ?? 0;
              total_tax.amount += line_tax.amount ?? 0;
          }
      }
      this.total_taxes_withheld = total_taxes_withheld;

      // Apply general discounts
      if (this.general_discounts && this.general_discounts.length > 0) {
        for (const discount of this.general_discounts) {
            const total_base = this.total_taxes.reduce((acc, t) => acc + t.base, 0);
            if (total_base === 0) {
                continue;
            }
            
            for (const t of this.total_taxes) {
                t.base -= actual_round((t.base / total_base) * (discount.amount ?? 0));
                t.amount = actual_round(t.base * t.rate);
                if (t.recargo_rate) {
                    t.recargo_amount = actual_round(t.base * t.recargo_rate);
                }
            }

            for (const t of this.total_taxes_withheld) {
              t.base -= actual_round((t.base / total_base) * (discount.amount ?? 0));
              t.amount = actual_round(t.base * t.rate);
            }

            const new_total_base = this.total_taxes.reduce((acc, t) => acc + t.base, 0);
            const error = actual_round((discount.amount ?? 0) - (total_base - new_total_base));
            if (error) {
                this.total_taxes[0].base -= error;
                this.total_taxes[0].amount = actual_round(this.total_taxes[0].base * this.total_taxes[0].rate);
                if (this.total_taxes[0].recargo_rate) {
                    this.total_taxes[0].recargo_amount = actual_round(this.total_taxes[0].base * this.total_taxes[0].recargo_rate);
                }
            }
        }
      }

      // Compute total amounts
      this.total_gross_amount = actual_round(this.lines.reduce((acc, l) => acc + l.gross_amount, 0));
      this.total_gross_amount_before_tax = actual_round(this.total_taxes.reduce((acc, t) => acc + t.base, 0));
      this.total_tax_amount = actual_round(this.total_taxes.reduce((acc, t) => acc + t.amount + (t.recargo_amount ?? 0), 0));
      this.total_withheld_amount = actual_round(this.total_taxes_withheld.reduce((acc, t) => acc + t.amount, 0));
      this.total_amount = actual_round(this.total_gross_amount_before_tax + this.total_tax_amount - this.total_withheld_amount);
      
      const reimbursable_amounts = this.reimbursable_amounts?.reduce((acc, amt) => acc + amt, 0) ?? 0;
      const ret_amount = this.retention_amount ?? 0;
      this.total_to_pay = actual_round(this.total_amount + reimbursable_amounts - ret_amount);
      
  }

  createRectificativeFromOriginal(original_inv:Invoiceable, invoice_number:string, invoice_date:string, configuration:Configuration): Invoiceable {
    const new_inv = this.clone();
    new_inv.state = 'draft';
    new_inv.invoice_date = new Date().toISOString().split('T')[0];
    new_inv.rectificative = true;
    new_inv.tax_type = configuration.tax_type;
    new_inv.rectificative_info = new RectificativeInfo(
        this.rectificative_info?.reason,
        this.rectificative_info?.invoice_id,
        invoice_number,
        invoice_date
    );
    // new_inv.rectificative_reason = this.rectificative_reason;
    new_inv.predicted_invoice_number = this.predicted_invoice_number;
    // new_inv.rectificative_invoice_id = original_inv.id;
    new_inv.predicted_rectificative_invoice_number = this.predicted_rectificative_invoice_number;

    if (original_inv) {
      const original_lines = original_inv.lines;
      const new_lines: InvoiceLine[] = [];
      for (const line of original_lines) {
        const new_line = line.clone();
        new_line.quantity = -new_line.quantity;
        new_line.total_cost = -new_line.total_cost;
        new_line.gross_amount = -new_line.gross_amount;
        new_line.id = undefined;
    
        new_line.taxes = new_line.taxes.map(tax => new Tax(tax.rate, -tax.base, -tax.amount, tax.recargo_rate, -tax.recargo_amount));
        
        new_line.taxes_withheld = new_line.taxes_withheld.map(tax => new Tax(tax.rate, -tax.base, -tax.amount));
        
        new_lines.push(new_line);
      }
      new_inv.lines = new_lines;
      new_inv.customer = original_inv.customer;
      new_inv.supplier = original_inv.supplier;
      new_inv.total_amount = -original_inv.total_amount;
      new_inv.total_to_pay = -original_inv.total_to_pay;
      new_inv.total_gross_amount = -original_inv.total_gross_amount;
      new_inv.total_gross_amount_before_tax = -original_inv.total_gross_amount_before_tax;
      new_inv.total_tax_amount = original_inv.total_tax_amount;
      new_inv.total_withheld_amount = original_inv.total_withheld_amount;
      new_inv.other_amounts = original_inv.other_amounts;
      new_inv.general_discounts = original_inv.general_discounts?.map(d => new ExtraAmount(d.reason, -d.amount, d.rate));
      new_inv.general_surcharges = original_inv.general_surcharges?.map(s => new ExtraAmount(s.reason, -s.amount, s.rate));
      new_inv.reimbursable_amounts = original_inv.reimbursable_amounts?.map(a => -a);
      new_inv.total_taxes = original_inv.total_taxes.map(t => new Tax(t.rate, -t.base, -t.amount, t.recargo_rate, -t.recargo_amount));
      new_inv.total_taxes_withheld = original_inv.total_taxes_withheld.map(t => new Tax(t.rate, -t.base, -t.amount));
      new_inv.retention_amount = -original_inv.retention_amount;
      new_inv.retention_concept = original_inv.retention_concept;
      new_inv.start_date = original_inv.start_date;
      new_inv.end_date = original_inv.end_date;
      new_inv.invoice_due_date = original_inv.invoice_due_date;
      new_inv.rectificative_info.invoice_date = original_inv.invoice_date;
      new_inv.rectificative_info.invoice_number = original_inv.invoice_number;
      new_inv.rectificative_info.invoice_id = original_inv.id;
    }
    return new_inv;
  }
    
}

export class Invoice extends Invoiceable {
  type: string = 'invoice';
  name: string = 'factura';
  actions: string[] = ['can_send_email', 'can_send_accounting', 'can_send_faceb2b2', 'can_send_face', 'can_download', 'has_paid_state', 'can_sign'];
}

export class RecInv extends Invoiceable {
  type: string = 'recurring_invoice_contract';
  name: string = 'factura';
}

export class Budget extends Invoiceable {
  type: string = 'budget';
  name: string = 'presupuesto';
  actions: string[] = ['can_send_email', 'can_download', 'can_mark_as_accepted_or_rejected'];
}

export class DeliveryNote extends Invoiceable {
  type: string = 'delivery_note';
  name: string = 'albarán';
  actions: string[] = ['can_send_email', 'can_download'];
}
export class Proforma extends Invoiceable {
  type: string = 'proforma';
  name: string = 'proforma';
  actions: string[] = ['can_send_email', 'can_download'];
}

